import { render } from "./Pagination.vue?vue&type=template&id=e41deafa&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=e41deafa&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-e41deafa"

export default script